import React from "react";
import ListingLoader from "../../component/LoaderTemplate";
import NoDataFound from "../../component/NoDataFound";
import { STATUS } from "../../constant";
import { isValidArray } from "../../helper";
import AgendaList from "./PragatiListSingle";
import { AgendaListTemplate } from "../../component/LoadersTemplate";

export default ({ agendaList, agendaListDto = {}, isLoading,calenderFilterloading ,paginationloading}) => {
  return (
    <div className="agenda-details-wrapper" style={{marginLeft:isLoading === STATUS.LOADING || calenderFilterloading || paginationloading?null:"-1%",width:isLoading === STATUS.LOADING || calenderFilterloading || paginationloading ?null:"101%",marginTop:"2%"}}>
      {isLoading === STATUS.LOADING || calenderFilterloading || agendaList==null || paginationloading ? (
        <ListingLoader
          parentClass="agenda-loader"
          times={10}
          height={182}
          children={<AgendaListTemplate />}
        />
      ) : isValidArray(agendaList) ? (
        agendaList.map((listDTO, index) => (
          <AgendaList
            pragatiDetails={listDTO}
            agendaListDto={agendaListDto}
            key={index}
          />
        ))
      ) : (
        <NoDataFound pragatipage={true} />
      )}
    </div>
  );
};
